import ShippingOptions from './BoxConfirm';
import { withI18n } from 'react-i18next';

export default withI18n()(ShippingOptions);
